<template>
    <span
        class="bundle-deal-link theme-primary-color"
        role="button"
        @click.stop.prevent="$emit('click')"
    >
        <span class="bundle-deal-link__label">{{ label }}</span>
        <!-- Chevron that turns into an arrow on hover (Figma: shaft grows as the chevron slides out). -->
        <svg
            class="bundle-deal-link__arrow"
            viewBox="0 0 16 16"
            aria-hidden="true"
        >
            <rect
                class="bundle-deal-link__shaft"
                x="3.33"
                y="7.33"
                width="10"
                height="1.33"
                rx="0.67"
            />
            <path
                class="bundle-deal-link__chevron"
                d="M6 4l4 4-4 4"
            />
        </svg>
    </span>
</template>

<script>
// Catalog card link to the "Also Available As" popup, for a product that is also sold in a bundle.
export default {
    props: {
        label: {
            type: String,
            default: "Available in a bundle deal",
        },
    },
};
</script>
